import { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import { Button } from '../../../iba-components/Button'
import { updateUser } from '../../actions/userInfo'
import { clearFilter, updateFilter } from '../../actions/filterInfo'
import LoadingMask from '../../components/LoadingMask'
import { LANG_JP } from '../../constants'
import { auth, doLogin } from '../../utils/loginUtils'
import classnames from 'classnames'
import i18next from 'i18next'
import './index.css'
import styles from './index.module.css'

class LoginPrd extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            loginable: true,
            jpfontsize: ''
        }
    }

    componentDidMount() {
        const url = new URL(window.location.href)
        const searchParams = new URLSearchParams(url.search)
        const token = searchParams.get('code')
        if (token) {
            this.handleLogin(token)
        }
        const lang = i18next.getLang()
        if (lang === LANG_JP) {
            this.setState({ jpfontsize: 'jp-font' })
        }
    }

    handleLogin = async (token) => {
        const { userInfoActions, filterInfoActions, history, t } = this.props
        await doLogin(token, {
            updateUser: userInfoActions.updateUser,
            updateFilter: filterInfoActions.updateFilter,
            history,
            t,
            onLoadingChange: (loading) => this.setState({ loading }),
            onLoginableChange: (loginable) => this.setState({ loginable })
        })
    }

    handleAuth = () => {
        auth(this.state.loginable)
    }

    render() {
        const { t } = this.props

        return (
            <div className="login-container">
                <div className="a-login-wrapper login-div a-increase-child-color-level-by-1">
                    <div className="a-login-upper-info center-align">
                        <div className="a-login-logo a-pwc-theme-adapt-logon" />
                        <div
                            className={classnames(
                                'a-login-title a-apply-theme-font-default-white',
                                this.state.jpfontsize
                            )}
                        >
                            {t('common.pageTitle')}
                        </div>
                    </div>
                    <div className="login-button-wrap">
                        <Button
                            className={styles.button}
                            size="sm"
                            width="150px"
                            label={t('common.login')}
                            disabled={!this.state.loginable}
                            onClick={this.handleAuth}
                        />
                    </div>
                </div>

                {this.state.loading && <LoadingMask />}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo,
        filterInfo: state.filterInfo
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        userInfoActions: bindActionCreators({ updateUser }, dispatch),
        filterInfoActions: bindActionCreators({ clearFilter, updateFilter }, dispatch)
    }
}

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPrd)))
